import React from "react";
import { Stack, CircularProgress, Badge } from "@mui/material";
import { ReactMultiEmail } from "react-multi-email";
import "react-multi-email/dist/style.css";
import ExpandableAccordion from "../../ExpandableAccordion";
import { ASSETS } from "../../../utils/config";
import { makeStyles } from "@material-ui/core/styles";
import Button from "../../Button";
import IyugaTooltip from "../../IyugaTooltip";

const useStyles = makeStyles((theme) => ({
  emailInputContainer: {
    border: "1px solid #ccc",
    borderRadius: 4,
    padding: 5,
    fontSize: 12,
    width: "100%",
  },
  emailInput: {
    border: "none",
    outline: "none",
    width: "100%",
  },
  emailItem: {
    display: "inline-block",
    backgroundColor: "#F6F7F9",
    borderRadius: 30,
    padding: "3px 6px",
    marginRight: 5,
  },
  email: {
    fontSize: "0.75rem",
    color: "#123051",
    fontFamily: "DM Sans",
    fontWeight: 400,
  },
  emailCross: {
    cursor: "pointer",
    marginLeft: 5,
    color: "#123051",
    fontSize: 16,
  },
}));

const EmailAccordion = ({
  emails = [],
  onChange = () => {},
  onFocus = () => {},
  onBlur = () => {},
  onUpdateButtonPress = () => {},
  onUsersIconPress = () => {},
  isLoading = false,
  isFetchingEmails = false,
  emailCount = 0,
}) => {
  const classes = useStyles();
  return (
    <Stack sx={{ flex: 1 }} direction={"row"} alignItems={"flex-start"}>
      <ExpandableAccordion
        rightIcon={ASSETS.segmentEditor.LockWheelEmailListIcon}
        titleIcon={ASSETS.linkHorizontalIcon}
        title={"Grant Access / Invite"}
        subtitle={"Invite guests to view your wheel via their email"}
        childrenStyle={{ pl: 4, flex: 1 }}
      >
        <Stack style={{ flex: 1 }} gap={2}>
          <div style={{ width: "100%", flex: 1 }}>
            <ReactMultiEmail
              emails={emails}
              onChange={onChange}
              className={classes.emailInputContainer}
              inputClassName={classes.emailInput}
              autoFocus={true}
              onFocus={onFocus}
              onBlur={onBlur}
              getLabel={(email, index, removeEmail) => {
                return (
                  <div data-tag key={index} className={classes.emailItem}>
                    <div className={classes.email}>{email}</div>
                    <span
                      className={classes.emailCross}
                      data-tag-handle
                      onClick={() => removeEmail(index)}
                    >
                      ×
                    </span>
                  </div>
                );
              }}
            />
          </div>
          <div
            style={{
              width: "10vw",
            }}
          >
            <Button
              isLoading={isLoading}
              disabled={emails?.length === 0}
              onClick={onUpdateButtonPress}
            >
              Update
            </Button>
          </div>
        </Stack>
      </ExpandableAccordion>

      {isFetchingEmails ? (
        <div
          style={{
            display: "flex",
            padding: 10,
            borderRadius: 5,
          }}
        >
          <CircularProgress size={24} />
        </div>
      ) : (
        <div
          onClick={onUsersIconPress}
          style={{
            padding: 10,
            borderRadius: 5,
            marginTop: 10,
          }}
        >
          <IyugaTooltip tooltip="View Emails with Access" placement="top">
            <Badge
              badgeContent={emailCount}
              color="primary"
              sx={{
                "& .MuiBadge-badge": {
                  fontSize: "0.75rem",
                  minWidth: "18px",
                  height: "18px",
                  borderRadius: "9px",
                  backgroundColor: "#9B5AF8",
                },
              }}
            >
              <img
                alt="rightIcon"
                src={ASSETS.segmentEditor.LockWheelEmailListIcon}
                style={{ height: "24px", width: "24px", cursor: "pointer" }}
              />
            </Badge>
          </IyugaTooltip>
        </div>
      )}
    </Stack>
  );
};

export default EmailAccordion;
